import { ReactElement } from 'react';
import { BigNumberCard } from './components/Card';
import { t } from 'i18next';
import { GenericDescriptionTooltipContent } from './styles';

export function ThermalComfort({ loading }: Readonly<{ loading: boolean }>): ReactElement {
  return (
    <BigNumberCard
      id="thermal-comfort"
      icon="Thermometer2Icon"
      number="-"
      description={{
        text: t('unidadesConfortaveis'),
        tooltip: <ThermalComfortTooltip />,
      }}
      subDescription={{
        number: 0,
        text: t('unidadesForaDaFaixaIdeal'),
      }}
      loading={loading}
      disabledTooltip={false}
      indicatorColor="transparent"
      comingSoon
      dataTestId="big-number-card-thermal-comfort"
    />
  );
}

function ThermalComfortTooltip() {
  return (
    <GenericDescriptionTooltipContent>
      <span>{t('emBreveVocePoderaAcompanharOConfortoTermicoDasSuasUnidades')}</span>
    </GenericDescriptionTooltipContent>
  );
}
